/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$('.navigation__has-sublinks').mouseenter(function(){
  $(this).removeClass('navigation__has-sublinks--collapsed');
});

// The cursor leaves the menu area
$('.navigation__has-sublinks').mouseleave(function(){
  $(this).addClass('navigation__has-sublinks--collapsed');
});